(function () {
  var roots = document.querySelectorAll('[data-hmg]');
  Array.prototype.forEach.call(roots, function (root) {
    var cfgEl = root.querySelector('[data-hmg-config]');
    if (!cfgEl) return;
    var CFG = {};
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var SWITCH_TEXT = CFG.switch || {};
    var GUARD = CFG.guard || {};
    var TITLES = CFG.titles || {};

    // 子犬（1歳未満）向けの注意書き。成犬用のみの商品を勧めないための文言。
    // セクション設定（guard_xxx）に同名のキーを入れた場合はそちらが優先される。
    var PUPPY_GUARD = {
      fd_fat_puppy: '体重が気になる子犬には、脂質高めの「ラム＆サーモン」以外のオールステージの味がおすすめです。',
      puppy_frozen: '冷凍手作りごはんは成犬用です。子犬には、主食ではなくトッピングとして全体の2割以内でお使いください。',
      puppy_dry: 'ドライの「ベニソン」とフリーズドライの「チキン＆ホキ」は成犬用です。子犬はそれ以外の味をお選びください。'
    };
    function puppyGuard(key) { return GUARD[key] || PUPPY_GUARD[key]; }

    var state = { age: '', concern: '', usage: '', freezer: '' };
    var history = [];
    var lastResult = null;
    var sessionId = 'hmg_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

    function param(name) {
      return new URLSearchParams(window.location.search).get(name) || '';
    }

    var pUse = param('use');
    var pConcern = param('concern');
    if (pUse === 'topping') state.usage = 'add';
    if (pUse === 'main') state.usage = 'main';
    if (pUse === 'homemade') { state.usage = 'main'; state.concern = 'homemade'; }
    if (pConcern) state.concern = pConcern;

    var STEP_ORDER = ['age', 'concern', 'usage', 'freezer'];

    function isStepNeeded(name) {
      if (name === 'age') return true;
      if (name === 'concern') return !state.concern;
      if (name === 'usage') return !state.usage;
      if (name === 'freezer') return state.concern === 'homemade' && state.usage !== 'consult' && !state.freezer;
      return false;
    }

    function neededSteps() {
      return STEP_ORDER.filter(isStepNeeded);
    }

    function decide() {
      if (state.usage === 'consult') return { primary: 'consult', alt: '' };
      if (state.concern === 'homemade') {
        if (state.freezer === 'no') return { primary: 'fd', alt: 'dry' };
        return { primary: 'frozen', alt: 'fd' };
      }
      if (state.usage === 'add' || state.usage === 'small') return { primary: 'fd', alt: 'frozen' };
      if (state.age === 'puppy' && state.concern === 'appetite') return { primary: 'dry', alt: 'fd' };
      if (state.concern === 'fat' || state.concern === 'senior') return { primary: 'dry', alt: 'fd' };
      return { primary: 'fd', alt: 'frozen' };
    }

    function showStep(name) {
      root.querySelectorAll('[data-hmg-step]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-hmg-step') === name);
      });
      // 子犬には「シニア期の食事」の選択肢を出さない（年齢と悩みの矛盾を防ぐ）
      if (name === 'concern') {
        var hideSenior = state.age === 'puppy';
        root.querySelectorAll('[data-hmg-step="concern"] [data-hmg-value="senior"]').forEach(function (b) {
          b.style.display = hideSenior ? 'none' : '';
        });
      }
      var progress = root.querySelector('[data-hmg-progress]');
      var steps = neededSteps();
      if (name === 'result') {
        progress.hidden = true;
      } else {
        progress.hidden = false;
        var idx = steps.indexOf(name);
        var pct = ((idx + 1) / (steps.length + 1)) * 100;
        root.querySelector('[data-hmg-fill]').style.width = pct + '%';
        root.querySelector('[data-hmg-count]').textContent = (idx + 1) + ' / ' + steps.length;
      }
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function nextFrom(current) {
      var idx = STEP_ORDER.indexOf(current);
      for (var i = idx + 1; i < STEP_ORDER.length; i++) {
        if (isStepNeeded(STEP_ORDER[i])) return STEP_ORDER[i];
      }
      return 'result';
    }

    function sendLog(extra) {
      var logUrl = root.getAttribute('data-hmg-log-url');
      if (!logUrl) return;
      var body = {
        result: lastResult ? lastResult.primary : '',
        age: state.age,
        concern: state.concern,
        usage: state.usage,
        freezer: state.freezer,
        page_url: window.location.href,
        session_id: sessionId
      };
      for (var k in extra) { body[k] = extra[k]; }
      try {
        fetch(logUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(body)
        });
      } catch (err) {
        // 送信失敗時は何もしない。回答結果の表示自体は継続する
      }
    }

    function renderResult() {
      var r = decide();
      lastResult = r;
      var isPuppy = state.age === 'puppy';

      // 子犬のときは、成犬用のみの冷凍手作りごはんを「こちらも合うかもしれません」に出さない
      var altKey = r.alt;
      if (isPuppy && altKey === 'frozen') altKey = '';

      function withDiagParams(url) {
        if (!url || url === '#') return url;
        var qp = new URLSearchParams();
        qp.set('diag_result', r.primary);
        if (state.age) qp.set('diag_age', state.age);
        if (state.concern) qp.set('diag_concern', state.concern);
        if (state.usage) qp.set('diag_usage', state.usage);
        if (state.freezer) qp.set('diag_freezer', state.freezer);
        // 診断ログとの突き合わせ用。注文のカート属性「診断_ID」に保存される
        qp.set('diag_sid', sessionId);
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        return url + sep + qp.toString();
      }

      root.querySelector('[data-hmg-result-title]').textContent = TITLES[r.primary] || '';
      root.querySelectorAll('[data-hmg-card]').forEach(function (card) {
        var isShown = card.getAttribute('data-hmg-card') === r.primary;
        card.hidden = !isShown;
        if (isShown) {
          var cta = card.querySelector('[data-hmg-cta]');
          if (cta) cta.setAttribute('href', withDiagParams(card.getAttribute('data-hmg-url')));
          var crosslink = card.querySelector('[data-hmg-crosslink]');
          if (crosslink) {
            var crossUrl = crosslink.getAttribute('data-hmg-crosslink-url');
            if (crossUrl) crosslink.setAttribute('href', withDiagParams(crossUrl));
          }
        }
      });
      var guardEl = root.querySelector('[data-hmg-guard]');
      var guards = [];
      if (isPuppy) guards.push(GUARD.puppy);
      if (state.age === 'senior') guards.push(GUARD.senior);
      if (state.concern === 'homemade' && state.freezer === 'no') guards.push(GUARD.freezer);
      // 「チキン＆ホキ」は成犬用。子犬には勧めない
      if (r.primary === 'fd' && state.concern === 'senior' && !isPuppy) guards.push(GUARD.fd_senior);
      if (r.primary === 'fd' && state.concern === 'fat') guards.push(isPuppy ? puppyGuard('fd_fat_puppy') : GUARD.fd_fat);
      if (r.primary === 'fd' && isPuppy && state.concern !== 'fat') guards.push(GUARD.puppy_fd_energy);
      if (r.primary === 'frozen' && state.age === 'senior') guards.push(GUARD.frozen_senior);
      if (r.primary === 'frozen' && isPuppy) guards.push(puppyGuard('puppy_frozen'));
      if (r.primary === 'dry' && isPuppy) guards.push(puppyGuard('puppy_dry'));
      guards = guards.filter(Boolean);
      if (guards.length) {
        var guardHtml = '<ul class="hmg__guard-list">';
        for (var gi = 0; gi < guards.length; gi++) {
          var gTxt = String(guards[gi]).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          guardHtml += '<li>' + gTxt + '</li>';
        }
        guardHtml += '</ul>';
        guardEl.innerHTML = guardHtml;
        guardEl.hidden = false;
      } else { guardEl.hidden = true; }

      var altEl = root.querySelector('[data-hmg-alt]');
      var altCard = altKey ? root.querySelector('[data-hmg-card="' + altKey + '"]') : null;
      if (altCard) {
        var altNameEl = root.querySelector('[data-hmg-alt-name]');
        altNameEl.textContent = altCard.getAttribute('data-hmg-name') || '';
        root.querySelector('[data-hmg-alt-link]').setAttribute('href', withDiagParams(altCard.getAttribute('data-hmg-url')) || '#');
        // 次点の短い説明（結果カードの「次点で表示する短い説明」）を名前の下に表示する
        var altShortEl = altEl.querySelector('[data-hmg-alt-short]');
        if (!altShortEl) {
          altShortEl = document.createElement('p');
          altShortEl.setAttribute('data-hmg-alt-short', '');
          altShortEl.style.cssText = 'margin:4px 0 10px;font-size:0.875rem;line-height:1.7;';
          altNameEl.parentNode.insertBefore(altShortEl, altNameEl.nextSibling);
        }
        altShortEl.textContent = altCard.getAttribute('data-hmg-short') || '';
        altShortEl.hidden = !altShortEl.textContent;
        altEl.hidden = false;
      } else { altEl.hidden = true; }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'meal_guide_result', result: r.primary,
          age: state.age, concern: state.concern, usage: state.usage, freezer: state.freezer
        });
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'meal_guide_result', {
          result: r.primary,
          age: state.age,
          concern: state.concern,
          usage: state.usage,
          freezer: state.freezer
        });
      }

      sendLog({});

      showStep('result');
    }

    root.querySelectorAll('[data-hmg-set]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-hmg-set');
        var current = btn.closest('[data-hmg-step]').getAttribute('data-hmg-step');
        state[key] = btn.getAttribute('data-hmg-value');
        // 子犬なのに「シニア期の食事」が先に入っていた場合は、悩みを選び直してもらう
        if (key === 'age' && state.age === 'puppy' && state.concern === 'senior') state.concern = '';
        btn.closest('.hmg__options').querySelectorAll('.hmg__opt').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        history.push(current);
        var next = nextFrom(current);
        if (next === 'result') renderResult(); else showStep(next);
      });
    });

    root.querySelectorAll('[data-hmg-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var prev = history.pop();
        if (prev) showStep(prev);
      });
    });

    root.querySelectorAll('[data-hmg-switch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-hmg-switch]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        var ans = root.querySelector('[data-hmg-switch-answer]');
        ans.textContent = SWITCH_TEXT[btn.getAttribute('data-hmg-switch')] || '';
        ans.hidden = false;
        sendLog({ current_food: btn.getAttribute('data-hmg-switch') });
      });
    });

    var restart = root.querySelector('[data-hmg-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { age: '', concern: '', usage: '', freezer: '' };
        history = [];
        root.querySelectorAll('.hmg__opt, .hmg__switch-opt').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        root.querySelector('[data-hmg-switch-answer]').hidden = true;
        showStep('age');
      });
    }

    showStep('age');
  });
})();
